(() => {
  const key = 'noire:wishlist';

  const read = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(key));
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  };

  const write = (items) => {
    try { window.localStorage.setItem(key, JSON.stringify(items)); } catch (error) {}
  };

  const page = document.querySelector('[data-wishlist-page]');
  if (!page) return;

  const grid = page.querySelector('[data-wishlist-grid]');
  const empty = page.querySelector('[data-wishlist-empty]');
  const loading = page.querySelector('[data-wishlist-loading]');
  const count = page.querySelector('[data-wishlist-count]');
  const moneyFormat = page.dataset.moneyFormat || '${{amount}}';

  const money = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, amount);
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  })[character]);

  const renderCard = (product) => {
    const variant = product.variants && product.variants[0];
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const compareAt = variant && variant.compare_at_price;
    const price = variant ? variant.price : product.price;
    const salePrice = compareAt > price
      ? `<s>${money(compareAt)}</s><strong>${money(price)}</strong>`
      : `<span>${money(price)}</span>`;

    return `
      <article class="nas-wishlist-card" data-wishlist-card="${escapeHtml(product.handle)}">
        <button class="nas-wishlist-card__remove" type="button" data-wishlist-remove="${escapeHtml(product.handle)}" aria-label="Remove ${escapeHtml(product.title)} from wishlist">♥</button>
        <a class="nas-wishlist-card__image" href="${escapeHtml(product.url)}">
          ${image ? `<img src="${escapeHtml(image)}&width=900" alt="${escapeHtml(product.title)}" loading="lazy" width="675" height="900">` : ''}
        </a>
        <div class="nas-wishlist-card__details">
          <a class="nas-wishlist-card__title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
          <div class="nas-wishlist-card__price">${salePrice}</div>
          <a class="nas-wishlist-card__cta button button--secondary" href="${escapeHtml(product.url)}">Choose options</a>
        </div>
      </article>`;
  };

  const updateState = () => {
    const items = read();
    count.textContent = `${items.length} ${items.length === 1 ? 'item' : 'items'}`;
    if (!items.length) {
      grid.hidden = true;
      empty.hidden = false;
    }
  };

  const load = async () => {
    const handles = read();
    count.textContent = `${handles.length} ${handles.length === 1 ? 'item' : 'items'}`;
    if (!handles.length) {
      loading.hidden = true;
      empty.hidden = false;
      return;
    }

    const results = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        return response.ok ? response.json() : null;
      } catch (error) {
        return null;
      }
    }));
    const products = results.filter(Boolean);
    const validHandles = products.map((product) => product.handle);
    if (validHandles.length !== handles.length) write(validHandles);
    grid.innerHTML = products.map(renderCard).join('');
    loading.hidden = true;
    grid.hidden = !products.length;
    empty.hidden = Boolean(products.length);
    updateState();
  };

  page.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-wishlist-remove]');
    if (!remove) return;
    const handle = remove.dataset.wishlistRemove;
    write(read().filter((item) => item !== handle));
    const card = remove.closest('[data-wishlist-card]');
    if (card) card.remove();
    updateState();
  });

  load();
})();
